"use client";

import dynamic from "next/dynamic";

// Lazy-loaded: @next/third-parties pulls in a ~3.7 MB chunk that the dev
// compile graph for every route would otherwise touch via the root layout.
// Loading client-only is safe; GA only sends events from the browser.
const GoogleAnalytics = dynamic(
  () => import("@next/third-parties/google").then((m) => m.GoogleAnalytics),
  { ssr: false },
);

export function GoogleAnalyticsLoader({ gaId }: { gaId: string }) {
  return <GoogleAnalytics gaId={gaId} />;
}
